<template>
  <!--Modal Nuevo Grupo-->
  <transition name="fade">
    <div class="modal-overlay">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <p class="modal-title" id="exampleModalLabel">Crear grupo</p>
            <!--<button type="button" class="closeModel" data-dismiss="modal" aria-label="Cerrar" @click="showModalEdit = false">
                  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                    <circle cx="15" cy="15" r="15" fill="#006C90"/>
                    <path d="M21 8.97714L19.7914 7.5L15 13.3562L10.2086 7.5L9 8.97714L13.7914 14.8333L9 20.6895L10.2086 22.1667L15 16.3105L19.7914 22.1667L21 20.6895L16.2086 14.8333L21 8.97714Z" fill="white"/>
                  </svg>
                </button>-->
          </div>
          <div class="modal-body">
            <label class="title-body">Nombre de grupo:</label><br />
            <input class="form-control" v-model="nombreGrupo" />
            <h6 class="mensajeError" v-if="mensajeInput">
              Debes asignar un nombre al grupo.
            </h6>
            <p class="mensaje">No ocupar caracteres especiales</p>

            <label class="title-body">Asignar Proveedores</label>
            <div class="correosList">
              <div
                v-for="(item, index) in idsSeleccionados"
                :key="index"
                class="correosSeleccionados"
                @click="quitarItem(item.id)"
              >
                {{ item.correo }}
              </div>
            </div>
            <select v-if="false"
              class="selectGroup select2"
              id="proveedores"
              v-model="selectedGroup"
              @change="add"
            >
              <option
                class="options"
                v-for="proveedor in proveedores"
                :key="proveedor.id"
                :value="proveedor.id"
              >
                {{ proveedor.contactoEmail }}
              </option>
            </select>
            <select2 v-model="selectedGroup" :options="proveedores" @select="add" :settings="{border: '10px solid #cecece'}" class="selectGroup" container-class="selectGroup">

            </select2>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-melon-secundario"
              @click="cancelarCreacion()"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-melon"
              @click="crearGrupo(nombreGrupo, idsSeleccionados)"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>

  <Loading v-if="loading"></Loading>
</template>

<script>
import { Actions } from "@/store/enums/StoreEnums";
import { ref } from "vue";
import { useStore } from "vuex";
import Loading from "@/components/Loading.vue";

export default {
  name: "NewGroup",
  emits: ["cancelar", "guardar"],
  components: {
    Loading,
  },
  data() {
    return {
      loading: false,
      nombreGrupo: "",
      idsSeleccionados: [],
    };
  },
  setup(props, { emit }) {
    const store = useStore();
    const proveedores = ref([]);
    const mensajeInput = ref(false);

    const fetchProveedores = async () => {
      try {
        const data = (await store.getters.allProveedores).map((proxy) => ({
          ...proxy,
        }));
        proveedores.value = data.filter((item) => item.contactoEmail != "");
        const value = proveedores.value.forEach(p=>{{
          p.text = p.contactoEmail
        }})
      } catch (error) {
        console.error(error);
      }
    };

    const cancelarCreacion = () => {
      emit("cancelar", null);
    };

    const crearGrupo = async (nombre, items) => {
      try {
        var ids = "";
        if (nombre != "") {
          items.forEach((element) => {
            ids = ids + element.id + ";";
          });
          var formData = new FormData();
          formData.append("values", ids);
          formData.append("nombre", nombre);

          const data = await store.dispatch(Actions.CREATE_GROUP, formData);
          emit("guardar", { data });
          //this.loading = false;
        } else {
          mensajeInput.value = true;
        }
      } catch (error) {
        console.log(error);
        //this.loading = false;
        emit("guardar", null);
      }
    };

    fetchProveedores();

    return {
      proveedores,
      cancelarCreacion,
      crearGrupo,
      mensajeInput,
    };
  },
  methods: {
    add() {
      if (this.selectedGroup) {
        const item = this.idsSeleccionados.find(
          (item) => item.id == this.selectedGroup
        );
        if (!item) {
          var proveedorSeleccionado;
          this.proveedores.forEach(i => {
            if(i.id == this.selectedGroup)
            {
              proveedorSeleccionado = i;
            }
          })
          this.idsSeleccionados.push({
            id: proveedorSeleccionado.id,
            correo: proveedorSeleccionado.contactoEmail,
          });
        } else {
          this.idsSeleccionados = this.idsSeleccionados.filter(
            (item) => item.id != this.selectedGroup
          );
        }
      }
    },
    quitarItem(id) {
      this.idsSeleccionados = this.idsSeleccionados.filter(
        (item) => item.id != id
      );
    },
  },
};
</script>

<style scoped>
.mensajeError {
  color: red;
}

.correosList {
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  flex-wrap: wrap;
}
.correosSeleccionados {
  color: var(--white, #fff);
  text-align: center;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 475;
  line-height: normal;
  border-radius: 10px;
  background: rgba(0, 108, 144, 0.4);
  padding: 0px 5px;
  cursor: pointer;
  margin: 5px;
}

.options {
  color: #99abb4;
  font-size: 0.8rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.mensaje {
  color: #99abb4;
  font-size: 0.7rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
/* .modal-overlay {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
}



.modal-header {
  height: 60px;
} */
.modal-dialog {
  /* position: fixed !important; */
  width: 35rem;
  /* top: 50px; */
}
.modal-title {
  color: #006c90;
  font-size: 1.18rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.closeModel {
  border: 0px;
  background-color: #fff;
}

.title-body {
  color: #99abb4;
  font-size: 0.9rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.selectGroup,
.inputNameGroup {
  /* border-radius: 50px; */
  border: 1px solid #cecece;
  background: #fff;
  width: 100%;

}

.btn-guardar {
  display: flex;
  width: 140px;
  height: 27px;
  padding: 5px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid #006c90;
  background: #006c90;
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  width: 45%;
}

.btn-cancelar {
  display: flex;
  width: 140px;
  height: 27px;
  padding: 5px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid #99c4d3;
  background: #99c4d3;
  color: #fff;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  width: 45%;
}

.modal-footer {
  padding: 0px 0px 1.5rem 0px !important;
  border: 0px !important;
  display: flex;
  justify-content: center;
}
</style>
